module.exports = __webpack_public_path__ + "static/media/desktopMainLogoEng.d7fefc38.jpeg";